export default "__VITE_ASSET__CDaDkyzT__"